import React from 'react';

type HeadingProps = {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: '6xl' | 'xl' | 'lg' | 'md' | 'sm';
  children: React.ReactNode;
  className?: string;
};

export const Heading: React.FC<HeadingProps> = ({
  as: Comp = 'h1',
  className,
  children,
  size = 'lg',
}) => {
  const sizeClasses = {
    '6xl': 'text-6xl md:text-7xl',
    xl: 'text-5xl md:text-6xl',
    lg: 'text-4xl md:text-5xl',
    md: 'text-3xl md:text-4xl',
    sm: 'text-2xl md:text-3xl',
  };

  return (
    <Comp
      className={`font-sans font-bold leading-tight tracking-tight text-slate-200 ${sizeClasses[size]} ${className || ''}`}
    >
      {children}
    </Comp>
  );
};
